import { useQuery } from "@tanstack/react-query";
import { getCampaignDomainSpotlight } from "./Spotlight.requests";

export const useSpotlight = (campaignId: string | number, domainId: number) => {
  return useQuery(["spotlight", campaignId, domainId], () =>
    getCampaignDomainSpotlight(campaignId, domainId)
  );
};
